var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "lat-lon-text" }, [
      _vm._v("\n    " + _vm._s(_vm.format ? "LAT/LON" : "LON/LAT") + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "coordinates-text",
        attrs: { id: "coordinatesDisplay" },
        on: {
          click: function ($event) {
            return _vm.$emit("click")
          },
        },
      },
      [
        _vm.lat == 0 && _vm.lon == 0
          ? _c("p", { staticClass: "no-drag coordinates-placeholder" }, [
              _vm._v("\n      RIGHT CLICK MAP\n    "),
            ])
          : _vm.format
          ? _c("p", { staticClass: "no-drag" }, [
              _vm._v(_vm._s(_vm.lat) + ","),
              _c("br"),
              _vm._v(_vm._s(_vm.lon)),
            ])
          : !_vm.format
          ? _c("p", { staticClass: "no-drag" }, [
              _vm._v(_vm._s(_vm.lon) + ","),
              _c("br"),
              _vm._v(_vm._s(_vm.lat)),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "coords-format swap-coords-format" },
      [
        _c("fa", {
          attrs: {
            icon: ["fas", "exchange-alt"],
            title: _vm.coordinateInput
              ? "Clear Input to swap format"
              : "Swap Format",
          },
          on: {
            click: () => {
              this.format = !this.format
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class:
          "coords-format copy-coords-format" +
          (_vm.lat == 0 && _vm.lon == 0 ? " copy-coords-format--disabled" : ""),
      },
      [
        _c("fa", {
          class: _vm.clipboardIcon == "clipboard-check" ? "green-check" : "",
          attrs: {
            icon: ["fas", _vm.clipboardIcon],
            title: "Copy Coordinates",
          },
          on: {
            click: function ($event) {
              return _vm.copyCoords()
            },
          },
        }),
        _vm._v(" "),
        _vm.clipboardIcon == "clipboard-check" && !_vm.showToggle
          ? _c("span", { staticClass: "copied-text" }, [_vm._v("COPIED")])
          : _vm.showToggle && (_vm.ansiComponent || _vm.drtComponents)
          ? _c("MMP_LatLongToggle", {
              ref: "latLongToggle",
              staticClass: "toggle-position",
              on: {
                toggleChange: function ($event) {
                  return _vm.$emit("toggleChange", $event)
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { class: "coordinates-input-field" + (_vm.expanded ? " active" : "") },
      [
        _c(
          "b-row",
          {
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.zoomToCoords()
              },
            },
          },
          [
            _c(
              "b-col",
              [
                _c("b-form-input", {
                  ref: "coordsInput",
                  staticClass: "no-drag",
                  attrs: {
                    placeholder: _vm.format
                      ? "Latitude, Longitude"
                      : "Longitude, Latitude",
                  },
                  model: {
                    value: _vm.coordinateInput,
                    callback: function ($$v) {
                      _vm.coordinateInput = $$v
                    },
                    expression: "coordinateInput",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-col",
              { staticClass: "no-drag", attrs: { cols: "2" } },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "go-btn",
                    attrs: { squared: "" },
                    on: {
                      click: function ($event) {
                        return _vm.zoomToCoords()
                      },
                    },
                  },
                  [_vm._v(" Go ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }